import React from 'react';

import { styled } from '@mui/material';
import { BoxProps } from '@mui/system';

import { Loader } from './Loader';

const Box = styled('div')((props) => {
  return {
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
    position: 'absolute',
    borderRadius: '4px',
    '> div': {
      margin: 0,
    },
  }
});

export const LoaderOverlay: React.FC<Pick<BoxProps, 'sx'>> = (props) => {

  return (
    <Box {...props}>
      <Loader />
    </Box>
  );
};
